export default __webpack_public_path__ + "static/media/Leftarrow.40166d9e.svg";